/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SelectPricingRuleRequestDTO interface.
 */
export function instanceOfSelectPricingRuleRequestDTO(value) {
    return true;
}
export function SelectPricingRuleRequestDTOFromJSON(json) {
    return SelectPricingRuleRequestDTOFromJSONTyped(json, false);
}
export function SelectPricingRuleRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
    };
}
export function SelectPricingRuleRequestDTOToJSON(json) {
    return SelectPricingRuleRequestDTOToJSONTyped(json, false);
}
export function SelectPricingRuleRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ruleId': value['ruleId'],
    };
}
